import * as React from 'react';
import { Image } from '@cian/ui-kit';
import { HonestWork } from '@cian/honestwork-component';

import { useApplicationContext } from '../../../../utils/applicationContext';
import { SuperAgentStar } from '../../../SuperAgent';

import * as styles from './index.css';

interface IProps {
  size: number;
  url?: string;
  hasFairplay?: boolean;
  isSuperAgentStarShown?: boolean;
}

export const PhotoMobile = ({ size, url, hasFairplay, isSuperAgentStarShown }: IProps) => {
  const applicationContext = useApplicationContext();
  const superAgentsEnabled = applicationContext.config.get<boolean>('demand.Superagents.Enabled') || false;

  return (
    <div className={styles['image_wrp']}>
      <Image src={url || ''} width={size} height={size} borderRadius="50%" objectFit="cover" />
      {superAgentsEnabled && isSuperAgentStarShown && (
        <div className={styles['star']}>
          <SuperAgentStar underlay />
        </div>
      )}
      {!superAgentsEnabled && hasFairplay && (
        <div className={styles['shield']}>
          <HonestWork isPopupDisabled />
        </div>
      )}
    </div>
  );
};
